import React from "react";
import "./AdminDashboardHome.css";

// One row of "Workload by User/Team" (Admin Command Centre redesign).
// `status` is a disclosed HEURISTIC computed in AdminDashboard.js from the
// real open/overdue counts (no backend-defined workload-status field
// exists) -- labeled as a estimate, never presented as a system fact.
const STATUS_LABEL = { overloaded: "Overloaded", balanced: "Balanced", low: "Low Workload" };

export default function WorkloadRow({ name, openCount, overdueCount, completedCount, status, barPct }) {
  return (
    <div className="adh-workload-row">
      <div className="adh-workload-name">{name}</div>
      <div className="adh-workload-track">
        <div className={`adh-workload-fill adh-workload-fill--${status}`} style={{ width: `${barPct}%` }} />
      </div>
      <div className="adh-workload-counts">
        <span title="Open tasks">{openCount} open</span>
        <span title="Overdue tasks" className={overdueCount > 0 ? "adh-workload-overdue" : ""}>{overdueCount} overdue</span>
        <span title="Completed tasks">{completedCount} completed</span>
      </div>
      <span className={`adh-workload-badge adh-workload-badge--${status}`}>{STATUS_LABEL[status]}</span>
    </div>
  );
}
